import BaseService from '@/api/services/BaseService';

const API_RESOURCE = 'sms/report';

export default class ReportService extends BaseService {
  static getMessagesToNumberForCurrentUser(number, fromDate, toDate, reportFormat) {
    const isWord = reportFormat === 'WORD';
    const URI = `${API_RESOURCE}`;
    const request = {
      idInfo: this.currentUserId,
      idType: 'USER',
      number,
      excludeAttachments: !isWord,
      reportFormat,
      fromDate,
      toDate
    };
    const options = {
      responseType: isWord ? 'arraybuffer' : 'blob'
    };
    return this.postRequestForData(URI, request, options);
  }

  static getAllMessagesForCurrentUser(fromDate, toDate, reportFormat) {
    const isWord = reportFormat === 'WORD';
    const URI = `${API_RESOURCE}`;
    const request = {
      idInfo: this.currentUserId,
      idType: 'USER',
      excludeAttachments: !isWord,
      reportFormat,
      fromDate,
      toDate
    };
    const options = {
      responseType: isWord ? 'arraybuffer' : 'blob'
    };
    return this.postRequestForData(URI, request, options);
  }
}
